<div class="container" style="margin-top: 21px;">
  <div class="row">
    <div>
      <h6>{{data.question}}</h6>
      <div [innerHTML]="answer" style="max-width: 400px;"></div>
    </div>
  </div>

  <div class="row" style="margin: 18px 0; justify-content: center;">
    <button mat-mini-fab color="primary"
      (click)="onClickCloseHelp()">
      <mat-icon>keyboard_arrow_down</mat-icon>
    </button>
  </div>

</div>